<template>
    <div class="page">
        <div class="page-content">
            <div class="bk-page">
                <img class="block-img" src="../assets/images/cards.png">
                <p class="block-title">按银行查询</p>
                <ul class="bank-list clearfix mb15">
                    <li v-for="item in bankList">
                        <div class="b-b">
                            <i class="icon"></i>
                            <h4>{{item['bank_name']}}</h4>
                            <p class="p1">{{item['bank_desc']}}</p>
                            <p class="p2">奖金 ¥{{item['bank_jj']}}</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            bankList: [{
                bank_name: '交通银行',
                bank_desc: '最红星期五',
                bank_jj: '110.00'
            }, {
                bank_name: '浦发银行',
                bank_desc: '小浦年中庆，积分嘉年华',
                bank_jj: '150.00'
            }, {
                bank_name: '上海银行',
                bank_desc: '周六美食半价',
                bank_jj: '90.00'
            }, {
                bank_name: '民生银行',
                bank_desc: '最快当天批卡',
                bank_jj: '70.00'
            }, {
                bank_name: '兴业银行',
                bank_desc: '移动兴支付，5折享不停',
                bank_jj: '80.00'
            }, {
                bank_name: '中信银行',
                bank_desc: '享多倍积分',
                bank_jj: '50.00'
            }, {
                bank_name: '光大银行',
                bank_desc: '10元享电影',
                bank_jj: '120.00'
            }, {
                bank_name: '招商银行',
                bank_desc: '周三五折美食',
                bank_jj: '40.00'
            }, {
                bank_name: '广发银行',
                bank_desc: '新户刷卡满额赏',
                bank_jj: '110.00'
            }, {
                bank_name: '华夏银行',
                bank_desc: '专享京东立减优惠',
                bank_jj: '50.00'
            }]
        }
    }
}
</script>
